import { Environment } from './environment.interface';

export const environment: Environment = {
  appUrl: 'https://dev.admin-desarrolladores.homein.mx',
  firebaseConfig: {
    apiKey: 'AIzaSyBMTXqH5sS-BKeUJrYHDvwbGJPm0z7ChX0',
    appId: '1:756336661481:web:cd6264beb0108be7aaf178',
    authDomain: 'santandermx-ha-dev.firebaseapp.com',
    measurementId: 'G-ERWQVVQ373',
    messagingSenderId: '756336661481',
    projectId: 'santandermx-ha-dev',
    storageBucket: 'santandermx-ha-dev.appspot.com',
    tenantId: 'real-estate-84nrd',
  },
  local: false,
  name: 'dev',
  production: false,
};
